import React from 'react';
import { useParams } from 'react-router-dom';

// components
import CommCenter from '../../../../components/CommCenter';

/**
 * My Studio sidebar. Same two tabs as the project page, but a cue tag jumps to
 * the cue on the timeline instead of the cue sheet.
 */
const CommCenterMyStudio = () => {
    const { projectId } = useParams();

    return (
        <CommCenter
            cueTarget="timeline"
            projectId={projectId}/>
    )
}

export default CommCenterMyStudio;
